import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {ReportChart} from '../../../../reports/report-chart';
import {DASHBOARD} from '../../../../reports/report-types';
import type {ChartReportParams} from '../../../../reports/report-types';

import {ChatbotReportProvider} from './chat-report-provider';

type Props = {
    activeFilters: FilterObject[];
    onChartClick?: (filters: FilterObject) => void | null | undefined;
    onParamChange: (arg1: any, arg2: boolean) => void;
    reportParams: ChartReportParams;
    reportDataSummary?: React.ReactNode;
    headerExtraContent?: React.ReactNode;
    height?: number;
    containerHeight?: number;
};

export function ChatbotChart(props: Props) {
    return (
        <ChatbotReportProvider>
            <ReportChart
                {...props}
                reportKey={DASHBOARD}
                hasBorder={false}
                hasGap={false}
                isFullWidth={true}
            />
        </ChatbotReportProvider>
    );
}
